module.exports = __webpack_public_path__ + "media/images/icons/country_flags/uy-2515d7371de19a0642e6a1cb2c59ef6a.svg";